import { api } from '@/shared/services/api';

// ============================================
// Types
// ============================================

export interface BankAccountData {
  iban: string;
  bankName: string;
  bankCode?: string;
  currency: string;
  isDefault: boolean;
}

export interface DelegateData {
  name: string;
  idCardSeries?: string;
  idCardNumber?: string;
  transportMeans?: string;
}

export interface WorkPointData {
  name?: string;
  street?: string;
  city?: string;
  county?: string;
  postalCode?: string;
}

export interface Step1Data {
  name: string;
  cui: string;
  jNumber?: string;
  caenCode?: string;
  legalForm?: string;
  capitalSocial?: number;
  website?: string;
  address?: {
    street?: string;
    city?: string;
    county?: string;
    postalCode?: string;
    country?: string;
  };
  workPoint?: WorkPointData;
  phone?: string;
  email?: string;
  scpTVA?: boolean;
  statusTvaIncasare?: boolean;
}

export interface Step2Data {
  invoiceSeriesPrefix: string;
  invoiceSeriesStartNumber: number;
  defaultCurrency: string;
  invoiceLanguage: string;
}

export interface Step3Data {
  vatRegime: string;
  taxPeriod: string;
  accountingType: string;
}

export interface Step4Data {
  bankAccounts: BankAccountData[];
  defaultPaymentTermDays: number;
  penaltyRate: string;
  warehouseName?: string;
  delegate?: DelegateData;
  nirDelegate?: DelegateData;
  issuerName?: string;
  issuerCnp?: string;
}

export interface Step5Data {
  efacturaEnabled: boolean;
  efacturaEnvironment: string;
}

export interface AnafCompanyData {
  cui: string;
  denumire: string;
  adresa: string;
  judet: string;
  localitate: string;
  codPostal: string;
  strada: string;
  scpTVA: boolean;
  statusTvaIncasare: boolean;
  dataInregistrareTVA: string | null;
  nrRegCom: string | null;
  tipActEconomic: string | null;
  statusInactiv: boolean;
  dataInactivare: string | null;
  dataReactivare: string | null;
  dataRadiere: string | null;
  telefon: string | null;
  stareInregistrare: string | null;
  isRadiata: boolean;
  dataRadiereFromStare: string | null;
  dataInregistrare: string | null;
  formaJuridica: string | null;
  formaOrganizare: string | null;
  formaProprietate: string | null;
  organFiscalCompetent: string | null;
  statusRoEFactura: boolean;
  dataInregRoEFactura: string | null;
  statusSplitTVA: boolean;
  fax: string | null;
}

export interface OnboardingStatus {
  currentStep: number;
  completed: boolean;
  data: {
    step1: Step1Data;
    step2: Step2Data;
    step3: Step3Data;
    step4: Step4Data;
    step5: Step5Data;
  };
  anafData?: {
    scpTVA: boolean | null;
    statusTvaIncasare: boolean | null;
    caenCode: string | null;
  };
}

// ============================================
// API
// ============================================

export const onboardingApi = {
  getStatus: () => api.get<OnboardingStatus>('/onboarding/status'),
  saveStep: (step: number, data: unknown) => api.patch(`/onboarding/steps/${step}`, data),
  complete: () => api.post<{ message: string }>('/onboarding/complete'),
  anafLookup: (cui: string) => api.get<AnafCompanyData>(`/onboarding/anaf-lookup/${cui}`),
};
